var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "pageEditorBoxWrapper" }, [
      _c("div", { staticClass: "pageEditorBox", style: _vm.boxStyle }, [
        _vm.showOfferingFrame
          ? _c("div", { staticClass: "frameContainer", style: _vm.boxStyle }, [
              _c("img", {
                attrs: {
                  crossOrigin: "Anonymous",
                  src: _vm.offeringFrame.url,
                  width: Math.round(_vm.frameWidth),
                  height: Math.round(_vm.frameHeight),
                },
              }),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          {
            class: [
              "pageViewContainer",
              "noUserSelect",
              { noBorder: _vm.showOfferingFrame },
            ],
            style: _vm.pageStyle,
            attrs: { id: "pageRegion" },
          },
          [
            _vm.showUI
              ? _c("PageEditorView", {
                  attrs: {
                    "bounding-box-height": _vm.pageHeight,
                    "bounding-box-width": _vm.pageWidth,
                    draggable: true,
                    "page-model": _vm.pageModel,
                    resizable: true,
                    rotatable: true,
                    scaling: _vm.scaling,
                    "show-template": true,
                    "show-bleed": _vm.showBleed,
                    "show-imagemap": true,
                    "smart-zoom": _vm.smartZoom,
                  },
                })
              : _vm._e(),
          ],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }